import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'
import { get, set } from 'lodash-es'

export default class extends Controller {
  static targets = ["addChoiceElement", "template", "elementList"]

  connect() {
    // Published forms will omit an elementListTarget and will not be sortable
    if (this.hasElementListTarget) {
      this.sortable = Sortable.create(this.elementListTarget, {
        handle: ".sub-handle"
      });
      this.isDraggableEnabled = false;
      this.toggleDraggable();
    }
  }

  toggleDraggable() {
    this.isDraggableEnabled = !this.isDraggableEnabled

    if (this.isDraggableEnabled) {
      this.sortable.option("disabled", false); // Enable dragging
    } else {
      this.sortable.option("disabled", true); // Disable dragging
    }
  }

  removeElement(e) {
    e.preventDefault();
    const element = e.currentTarget.closest(".element-answer");
    element.remove();
  }

  addElement(e) {
    e.preventDefault()
    const content = this.templateTarget.content.cloneNode(true)
    const newIdx = Date.now()
    let newName

    content.querySelectorAll('input').forEach(element => {
      newName = get(element, 'name').replace('NEW', newIdx)
      set(element, 'name', newName)
    });
    this.elementListTarget.appendChild(content)
  }
}
